import React from 'react'

const About4 = (props) => {

    return (
        <section className="about-page-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col col-lg-8 col-md-10">
                        <div className="section-title-s3">
                            <span>#About us</span>
                            <h2>Cultivating strong,</h2>
                            <h2><span>confident leaders,</span></h2>
                            <h2>who will positively impact the world. </h2>
                            <p>At our core, we empower individuals and strengthen communities through education, mentorship, and compassionate support. Guided by our core values of integrity, respect, community, passion, and diversity, we are committed to creating opportunities that foster growth, resilience, and hope, ensuring no one faces life’s challenges alone.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="about-features-grid">
                            <div className="grid">
                                <div className="icon">
                                    <i className="fi flaticon-money-bag"></i>
                                </div>
                                <h3>Financial Aid for Students</h3>
                                <p>We believe every student deserves access to education, regardless of financial
                                    background. Our financial aid programs provide direct support to students in
                                    need—helping cover tuition, books, uniforms, transportation, and other essential
                                    expenses so they can focus on their future, not their finances.</p>
                            </div>
                            <div className="grid">
                                <div className="icon">
                                    <i className="fi flaticon-triangular-ruler"></i>
                                </div>
                                <h3>Academic Resources & Support</h3>
                                <p>Education is a lifelong journey, and we’re here to support learners every step of the
                                    way. Whether you're in elementary school, college, or pursuing adult education, we
                                    provide access to school supplies, learning materials, and academic coaching
                                    resources. While we don’t offer tutoring directly, we offer financial assistance to
                                    help cover the cost for students who secure their own tutors. Our mission is to
                                    ensure that students of all ages have the resources they need to thrive—regardless
                                    of financial barriers or starting points.</p>
                            </div>
                            <div className="grid">
                                <div className="icon">
                                    <i className="fi flaticon-user"></i>
                                </div>
                                <h3>Mentorship for Young Adults</h3>
                                <p>Navigating life as a young adult can be overwhelming. Our mentorship program connects
                                    youth with caring, experienced mentors who guide them through personal growth,
                                    career exploration, goal setting, and building healthy relationships. We empower the
                                    next generation to lead with confidence and purpose.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="about-features-grid">
                            <div className="grid">
                                <div className="icon">
                                    <i className="fi flaticon-heart"></i>
                                </div>
                                <h3>Support for Survivors of Intimate Partner Violence</h3>
                                <p>Offering emotional support, resources, and advocacy for individuals overcoming the
                                    trauma of intimate partner violence, helping them heal and rebuild their lives.</p>
                            </div>
                            <div className="grid">
                                <div className="icon">
                                    <i className="fi flaticon-heart-1"></i>
                                </div>
                                <h3>Hope and Help After Life Transitions</h3>
                                <p>Life transitions can leave individuals feeling lost or alone—especially after
                                    experiences like divorce, intimate partner violence, job loss, or other major
                                    setbacks. We offer compassionate support through counseling referrals, resource
                                    navigation, empowerment coaching, and financial assistance. Whether someone needs
                                    help covering basic needs, rebuilding stability, or simply finding the strength to
                                    start again, we’re here to walk alongside them as they rebuild their lives with
                                    dignity and hope.
                                    .</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About4;